import { useState } from "react"
import PropTypes from "prop-types"
import Markdown from "markdown-to-jsx"
import { Box, Typography, Collapse, IconButton, Divider } from "@mui/material"
import { ExpandMore, ExpandLess, InfoOutlined } from "@mui/icons-material"
import ExternalLinks from "components/link"
import { useAnalytics } from "connected-components/analytics"
import { QUICK_ANSWERS_EVENTS } from "../analytics"

export default function TableGenerationSteps({ explanation, question }) {
  const analytics = useAnalytics()
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = () => {
    analytics.track(QUICK_ANSWERS_EVENTS.TABLE_GENERATION_STEPS_TOGGLED, {
      question,
      expanded: !isExpanded,
    })
    setIsExpanded(!isExpanded)
  }

  if (!explanation) {
    return null
  }

  return (
    <Box className="table-explanation">
      <Box className="explanation-trigger" onClick={handleToggle}>
        <Box className="trigger-content">
          <InfoOutlined fontSize="small" />
          <Typography variant="body2" className="trigger-text">
            How was this table generated?
          </Typography>
        </Box>
        <IconButton size="small" className="expand-icon" disableRipple>
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box className="explanation-content">
          <Divider className="explanation-divider" />
          <Typography variant="subtitle2" className="explanation-title">
            Table Generation Steps
          </Typography>
          <Box className="explanation-steps">
            <Box className="explanation-step">
              <Box className="step-content">
                <div className="explanation-markdown">
                  <ExternalLinks>
                    <Markdown>{explanation}</Markdown>
                  </ExternalLinks>
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Box>
  )
}

TableGenerationSteps.propTypes = {
  explanation: PropTypes.shape({
    steps: PropTypes.arrayOf(PropTypes.string),
  }),
  question: PropTypes.string.isRequired,
}
